import React from 'react';
import KTileItem from './KTileItem';
import { KTileDTO, Place } from '@envclient/envengine/src/envs/koenigsburg/KTile';
import { getKTileDef } from '../../config/kTileMapConfig';

const createKTileItem = (tileType: number) => {
  const tileDef = getKTileDef(tileType);
  const tileDTO: KTileDTO = {
    id: 0,
    type: tileDef.type,
    rot: 0,
    shape: tileDef.shape,
    place: new Place(tileDef.shape, []),
    isTemp: false,
    taxMeeples: []
  };
  return <KTileItem tile={tileDTO} active={false} />;
};

export default createKTileItem;
